module.exports = __webpack_public_path__ + "img/view_10.7cfdb909.jpg";